(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
window.addEventListener("render-accordions", function () {
  processAccordions();
});
window.addEventListener("load", function () {
  processAccordions();
});
function processAccordions() {
  window.addEventListener("resize", function () {
    panelWidthFix();
  });
  setBoxAccordionTopHeight();
  youTubeKeyboardAccessibility();
  document.querySelectorAll(".Accordion").forEach(function (accordion) {
    // Allow for multiple accordion sections to be expanded at the same time
    var allowMultiple = false; // we don't want multiple accordion sections to be expanded at the same time

    // Allow for each toggle to both open and close individually
    var allowToggle = accordion.hasAttribute("data-allow-toggle");

    // Create the array of toggle elements for the accordion group
    var triggers = _toConsumableArray(accordion.querySelectorAll(".Accordion-trigger"));
    var panels = _toConsumableArray(accordion.querySelectorAll(".Accordion-panel"));
    triggers.map(function (target) {
      panelWidthFix(accordion, target);
    });
    accordion.addEventListener("click", function (event) {
      var target = event.target;
      target.parentElement.parentElement.classList.contains("Accordion-trigger") ? target = target.parentElement.parentElement : target.parentElement.classList.contains("Accordion-trigger") ? target = target.parentElement : ""; // Kind of a hack to set target element correctly

      if (target.classList.contains("Accordion-trigger")) {
        // Check if the current toggle is expanded.
        var isExpanded = target.getAttribute("aria-expanded") == "true";
        var active = accordion.querySelector('[aria-expanded="true"]');

        // without allowMultiple, close the open accordion
        if (!allowMultiple && active && active !== target) {
          // Set the expanded state on the triggering element
          active.setAttribute("aria-expanded", "false");
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(active.getAttribute("aria-controls")).setAttribute("hidden", "");

          // When toggling is not allowed, clean up disabled state
          if (!allowToggle) {
            active.removeAttribute("aria-disabled");
          }
        }
        if (!isExpanded) {
          document.querySelectorAll(".box-accordion-top").forEach(function (boxAccordionTop) {
            return boxAccordionTop.setAttribute("aria-expanded", false);
          });
          document.querySelectorAll(".Accordion-panel").forEach(function (accordionPanel) {
            accordionPanel.setAttribute("aria-hidden", false);
            accordionPanel.setAttribute("hidden", false);
          });

          // Set the expanded state on the triggering element
          target.setAttribute("aria-expanded", "true");

          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(target.getAttribute("aria-controls")).removeAttribute("hidden");

          // If toggling is not allowed, set disabled state on trigger
          if (!allowToggle) target.setAttribute("aria-disabled", "true");
        } else if (allowToggle && !!isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute("aria-expanded", "false");
          // Hide the accordion sections, using aria-controls to specify the desired section

          var ariaControlsTarget = document.getElementById(target.getAttribute("aria-controls"));
          ariaControlsTarget.setAttribute("aria-hidden", true);
          ariaControlsTarget.setAttribute("hidden", true);
        }
        event.preventDefault();
      }
      var scrollElement = document.getElementById(accordion.id);
      scrollElement ? scrollElement.scrollIntoView({
        behavior: "smooth"
      }) : "";
    });

    // Bind keyboard behaviors on the main accordion container
    accordion.addEventListener("keydown", function (event) {
      var target = event.target;
      var key = event.which.toString();

      // var isExpanded = target.getAttribute("aria-expanded") == "true";
      // var allowToggle = allowMultiple
      //   ? allowMultiple
      //   : accordion.hasAttribute("data-allow-toggle");

      // 33 = Page Up, 34 = Page Down
      var ctrlModifier = event.ctrlKey && key.match(/33|34/);

      // Is this coming from an accordion header?
      if (target.classList.contains("Accordion-trigger")) {
        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          var index = triggers.indexOf(target);
          var direction = key.match(/34|40/) ? 1 : -1;
          var length = triggers.length;
          var newIndex = (index + length + direction) % length;
          triggers[newIndex].focus();
          event.preventDefault();
        } else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
            // Go to first accordion
            case "36":
              triggers[0].focus();
              break;
            // Go to last accordion
            case "35":
              triggers[triggers.length - 1].focus();
              break;
          }
          event.preventDefault();
        }
      }
    });

    // These are used to style the accordion when one of the buttons has focus
    accordion.querySelectorAll(".Accordion-trigger").forEach(function (trigger) {
      trigger.addEventListener("focus", function (event) {
        // accordion.classList.add('focus');
        event.target.classList.add("focus");
      });
      trigger.addEventListener("blur", function (event) {
        accordion.classList.remove("focus");
        event.target.classList.remove("focus");
      });
    });

    // Minor setup: will set disabled state, via aria-disabled, to an
    // expanded/ active accordion which is not allowed to be toggled close
    if (!allowToggle) {
      // Get the first expanded/ active accordion
      var expanded = accordion.querySelector('[aria-expanded="true"]');

      // If an expanded/ active accordion is found, disable
      if (expanded) {
        expanded.setAttribute("aria-disabled", "true");
      }
    }
  });
  window.addEventListener("resize", function () {
    _toConsumableArray(document.querySelectorAll(".Accordion")).map(function (accordion) {
      _toConsumableArray(accordion.querySelectorAll(".Accordion-trigger")).map(function (target) {
        panelWidthFix(accordion, target);
      });
    });
    setBoxAccordionTopHeight();
  });
  var accordion_card_array = _toConsumableArray(document.querySelectorAll(".Card-Accordion"));
  var accordion_card_content_links_array = _toConsumableArray(document.querySelectorAll(".card-accordion-content a"));
  accordion_card_content_links_array.map(function (link) {
    link.setAttribute("tabindex", "-1");
  });
  accordion_card_array.map(function (cardAccordion) {
    cardAccordion.querySelector(".card-accordion-toggle a").addEventListener("click", function (evt) {
      toggleCardAccordion(evt, cardAccordion);
    });
    cardAccordion.addEventListener("keydown", function (evt) {
      if (evt.target.classList.contains("container") && evt.target.classList.contains("Card-Accordion")) {
        cardAccordion.tabIndex = "-1";
      }
    });
    cardAccordion.querySelector(".card-accordion-toggle a").addEventListener("keydown", function (event) {
      if (event.code.toLowerCase() === "space" || event.key.toLowerCase() === "enter") {
        event.preventDefault();
        toggleCardAccordion(event, cardAccordion);
        var showContent = cardAccordion.querySelector(".card-accordion").classList.contains("show");
        var tabIndex = !!showContent ? "0" : "-1";
        cardAccordion.tabIndex = tabIndex;
        !!showContent ? cardAccordion.focus() : cardAccordion.blur();
      }
    });

    // cardAccordion
    //   .querySelector(".card-accordion-toggle a")
    //   .addEventListener("keydown", (event) => {
    //     if (
    //       event.code.toLowerCase() === "space" ||
    //       event.key.toLowerCase === "enter"
    //     ) {
    //       event.preventDefault();
    //       toggleCardAccordion(event, cardAccordion);

    //       const showContent = cardAccordion
    //         .querySelector(".card-accordion")
    //         .classList.contains("show");
    //       const tabIndex = !!showContent ? "0" : "-1";

    //       cardAccordion.tabIndex = tabIndex;
    //       !!showContent ? cardAccordion.focus() : cardAccordion.blur();
    //     }
    //   });
  });
  document.body.addEventListener("click", function (evt) {
    var tabbedAccordions = document.querySelectorAll(".Card-Accordion[tabindex='0']");
    if (!!tabbedAccordions) {
      tabbedAccordions.forEach(function (accordion) {
        accordion.removeAttribute("tabindex");
      });
    }
  });
}
function toggleCardAccordion(evt, cardAccordion) {
  evt.preventDefault();
  cardAccordion.tabIndex = "-1";
  cardAccordion.blur();
  var target = evt.target;
  target.parentElement.parentElement.parentElement.classList.contains("Card-Accordion") ? target = target.parentElement.parentElement.parentElement : target.parentElement.parentElement.classList.contains("Card-Accordion") ? target = target.parentElement.parentElement : target.parentElement.classList.contains("Card-Accordion") ? target = target.parentElement : "";
  if (target.querySelector(".card-accordion-content")) {
    var content_links = cardAccordion.querySelectorAll(".card-accordion-content a");
    target.querySelector(".Card-Accordion .card-accordion").classList.toggle("show");
    target.querySelector(".card-accordion-toggle > a").classList.toggle("card-accordion-show-less");
    if (target.querySelector(".Card-Accordion .card-accordion").classList.contains("show")) {
      var focusedElement = document.querySelector(".Card-Accordion :focus");
      if (focusedElement) focusedElement.blur();
      for (var i = 0; i < content_links.length; i++) content_links[i].setAttribute("tabindex", "0");
      target.scrollIntoView({
        behavior: "smooth"
      });
      target.querySelector(".card-accordion-toggle > a").innerHTML = "Show Less";
    } else {
      for (var _i = 0; _i < content_links.length; _i++) content_links[_i].setAttribute("tabindex", "-1");
      var toggleLink = target.querySelector(".card-accordion-toggle a");
      if (!!toggleLink) toggleLink.innerHTML = "Show More";
      target.scrollIntoView({
        behavior: "smooth"
      });
    }
    youTubeKeyboardAccessibility();
  }
}
function panelWidthFix(accordionBlock, accordionTarget) {
  if (!!accordionTarget) {
    var targetPanel = accordionBlock.querySelector("#".concat(accordionTarget.getAttribute("aria-controls")));
    var offset = (accordionTarget.offsetLeft - accordionBlock.offsetLeft) * -1 + 10 + "px";
    targetPanel.style.marginLeft = offset;
    targetPanel.style.width = "".concat(accordionBlock.offsetWidth - 20, "px");
  }
}
function setBoxAccordionTopHeight() {
  document.querySelectorAll(".box-accordion-top").forEach(function (boxAccordion) {
    setTimeout(setHeight, 100);
    function setHeight() {
      var height = boxAccordion.getBoundingClientRect().height;
      boxAccordion.style.height = window.innerWidth >= 760 ? height + "px" : null;
    }
  });
}
function youTubeKeyboardAccessibility(open) {
  var accordions = document.querySelectorAll(".card-accordion");
  if (!!accordions) {
    accordions.forEach(function (accordion) {
      var youTubeIframe = accordion.querySelector("iframe[data-src*='youtube.com']");
      if (!!youTubeIframe) {
        var tabIndexValue = accordion.classList.contains("show") ? "0" : "-1";
        youTubeIframe.tabIndex = tabIndexValue;
      }
    });
  }
}

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;
var general_utils = _interopRequireWildcard(require("../_utils/general_utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function setup() {
  window.addEventListener("DOMContentLoaded", function () {
    processBackToTop();
  });
  window.addEventListener("resize", function () {
    processBackToTop();
  });
  window.addEventListener("scroll", function () {
    processBackToTop();
  });
}
function processBackToTop() {
  var pixelCount = setWhenVisible();
  var backToTopButton = document.querySelector(".back-to-top");
  if (backToTopButton) {
    backToTopButton.addEventListener("click", function (event) {
      event.preventDefault();
      window.scrollTo(0, 0);
    });
    if (window.scrollY >= pixelCount) backToTopButton.classList.add("show");
    if (window.scrollY < pixelCount) backToTopButton.classList.remove("show");
  }
}
function setWhenVisible() {
  var deviceType = general_utils.detectDeviceType();
  var pixels = 3946;
  if (deviceType === "desktop") pixels = 3852;
  if (deviceType === "phone") pixels = 3520;
  if (deviceType === "ipad") pixels = 4468;
  return pixels;
}

},{"../_utils/general_utils":15}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeActiveFromUnchecked = removeActiveFromUnchecked;
function removeActiveFromUnchecked(cardClass) {
  var cardInputs = document.querySelectorAll(".".concat(cardClass, " input"));
  cardInputs.forEach(function (input) {
    var card = input.closest(".".concat(cardClass));
    if (!!card && !input.checked) card.classList.remove("checked");
  });
}

},{}],4:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var checkboxes_and_radios = _interopRequireWildcard(require("./checkboxes_and_radios"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
window.addEventListener("load", function (event) {
  checkboxes_and_radios.checkboxCards();
  checkboxes_and_radios.radioButtonCards();
});

},{"./checkboxes_and_radios":5}],5:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxCards = checkboxCards;
exports.radioButtonCards = radioButtonCards;
var form_utils = _interopRequireWildcard(require("./_form-utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function checkboxCards() {
  setCardEvents("checkbox-card");
}
function radioButtonCards() {
  setCardEvents("radio-button-card");
}
function setCardEvents(cardClass) {
  var cardInputs = document.querySelectorAll(".".concat(cardClass, " input"));
  if (!!cardInputs) {
    cardInputs.forEach(function (input) {
      var card = input.closest(".".concat(cardClass));
      input.addEventListener("click", function (_) {
        if (!!card) {
          if (!!input.checked) card.classList.add("checked");
          if (!input.checked) card.classList.remove("checked");
        }
        form_utils.removeActiveFromUnchecked(cardClass);
      });
    });
  }
}

},{"./_form-utils":3}],6:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleKeyboard = handleKeyboard;
exports.keyboardEventListeners = keyboardEventListeners;
var mm_utils = _interopRequireWildcard(require("../farmers_mm_utils.js"));
var mm_accessibility_keyboard = _interopRequireWildcard(require("./farmers_mm_accessibility_keyboard.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function handleKeyboard(event) {
  if (event.keyCode == 27) mm_accessibility_keyboard.escapeKey(event);
  if (event.keyCode == 36 || event.keyCode == 35) mm_accessibility_keyboard.homeEnd(event);
  if (event.keyCode == 39) mm_accessibility_keyboard.topLevelArrows("right");
  if (event.keyCode == 37) mm_accessibility_keyboard.topLevelArrows("left");
  if (event.keyCode == 38) mm_accessibility_keyboard.secondLevelArrows(event, "up");
  if (event.keyCode == 40) mm_accessibility_keyboard.secondLevelArrows(event, "down");
  document.querySelectorAll(".tbm .level-2").forEach(function (link) {
    link.addEventListener("keyup", function (event) {
      event.stopImmediatePropagation();
      event.preventDefault();

      // if (event.keyCode === 13) {
      // 	if (event.target.classList.contains("page-link")) return;
      // }
    });
  });
}
function keyboardEventListeners() {
  document.body.addEventListener("keyup", function (event) {
    if (event.key.toLowerCase() === "tab" && !document.querySelector(".primary-nav-wrap :focus")) mm_utils.closeAllMenus(event);
  });
}

// export function ariaCheck() {
//   document.querySelectorAll("li.tb-megamenu-item").forEach((element) => {
//     const link = element.querySelector("a.dropdown-toggle");
//     if (link) {
//       let ariaExpanded = false;
//       if (element.classList.contains("open")) ariaExpanded = true;
//       link.setAttribute("aria-expanded", ariaExpanded);
//     }
//   });
// }

},{"../farmers_mm_utils.js":10,"./farmers_mm_accessibility_keyboard.js":7}],7:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeKey = escapeKey;
exports.homeEnd = homeEnd;
var mm_utils = _interopRequireWildcard(require("../farmers_mm_utils"));
var general_utils = _interopRequireWildcard(require("../../../../_utils/general_utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// this file to be used for specific key events
// anything else for accessiblity should go in farmers_mm_accessibility.js

var plainLinkHoverClass = "sidemenu-hover-plain";
var topLevelLinks = document.querySelectorAll(".tbm-item.level-1 a");
var firstLevel = document.querySelectorAll(".tbm .tbm-item.level-1");
var firstLevelArray = general_utils.convertNodeListToArray(firstLevel);
function escapeKey(event) {
  mm_utils.closeAllMenus(event);
}
function homeEnd(event) {
  event.preventDefault();
  var firstLevelSelector = event.keyCode === 36 ? ".tbm-item.level-1" : ".tbm-item.level-1:last-child";
  var level2Selector = event.keyCode === 36 ? ".tbm-nav .tbm-item.level-1.open .level-2:first-of-type" : ".tbm-nav .tbm-item.level-1.open .level-2:last-child";
  var openLevel2Item = document.querySelector(".tbm .tbm-item.level-2.open");
  if (document.querySelector(".tbm ".concat(firstLevelSelector)) && !openLevel2Item) {
    // mm_utils.removeHoverFromLevel2Links(true);
    var linkIndex = event.keyCode === 36 ? 0 : topLevelLinks.length - 1;
    topLevelLinks[linkIndex].focus();
  }
  if (openLevel2Item) {
    // mm_utils.removeHoverFromLevel2Links();
    var link = document.querySelector("".concat(level2Selector, " a"));

    // if (link) {
    // 	if (!link.classList.contains("sidemenu-hover"))
    // 		link.classList.add(plainLinkHoverClass);
    // 	link.focus();
    // }
  }
}

// export function topLevelArrows(direction) {
// 	const focusedLink = document.querySelector(".tbm .level-1 a:focus");

// 	if (!!focusedLink) {
// 		const linkTitle = focusedLink.querySelector(".mm-top-level-title");
// 		if (!!linkTitle) {
// 			const index = firstLevelArray.indexOf(
// 				document.querySelector(
// 					`li[data-label="${linkTitle.textContent}"]`,
// 				),
// 			);
// 			const newIndex = direction === "right" ? index + 1 : index - 1;

// 			if (firstLevelArray[newIndex]) {
// 				document.querySelector(".tbm .level-1 a:focus").blur();
// 				firstLevelArray[newIndex].querySelector("a").focus();
// 			}
// 		}
// 	}
// }

// export function secondLevelArrows(event, direction) {
// 	event.preventDefault();
// 	const linkArray = general_utils.convertNodeListToArray(
// 		document.querySelectorAll(".tbm .level-1.open li.level-2"),
// 	);
// 	const focusedLink = document.querySelector(
// 		".tbm .level-1.open li.level-2 a:focus",
// 	);

// 	const currentLink = focusedLink
// 		? focusedLink
// 		: document.querySelector(
// 				".tbm .level-1.open li.level-2 a.sidemenu-hover",
// 		  );

// 	const secondLevelElement = currentLink
// 		? document.querySelector(
// 				`.tbm .level-1.open li.level-2[data-label="${currentLink.getAttribute(
// 					"data-category",
// 				)}"]`,
// 		  )
// 		: null;

// 	if (secondLevelElement) {
// 		const index = linkArray.indexOf(secondLevelElement);
// 		const newIndex = direction === "down" ? index + 1 : index - 1;

// 		if (linkArray[newIndex]) {
// 			const oldLink = linkArray[index].querySelector("a");
// 			const newLink = linkArray[newIndex].querySelector("a");

// 			oldLink.classList.remove(plainLinkHoverClass);
// 			newLink.classList.add(plainLinkHoverClass);
// 			oldLink.blur();
// 			newLink.focus();
// 		}
// 	}
// }

},{"../../../../_utils/general_utils":15,"../farmers_mm_utils":10}],8:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGridLinksContainer = createGridLinksContainer;
exports.setupFeaturedLinksContainer = setupFeaturedLinksContainer;
exports.setupFirstLevelTab = setupFirstLevelTab;
exports.setupLandingPageLink = setupLandingPageLink;
exports.setupLandingPageLinkNoSubmenu = setupLandingPageLinkNoSubmenu;
exports.setupMobileGridLinks = setupMobileGridLinks;
var general_utils = _interopRequireWildcard(require("../../../_utils/general_utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function setupFirstLevelTab(firstLevel, categoryName, linksContainer) {
  var sectionHeader = firstLevel.querySelector("a:first-of-type");
  var categoryHeader = document.createElement("div");
  categoryHeader.id = "mm-mobile-menu-".concat(general_utils.webFriendlyName(categoryName));
  categoryHeader.classList.add("mm-mobile-nav-category");

  // append main category header
  categoryHeader.textContent = categoryName;
  linksContainer.appendChild(categoryHeader);
}
function setupMobileGridLinks(firstLevel, submenus, linksContainer) {
  submenus.forEach(function (submenu) {
    submenu = submenu.cloneNode(true);
    var categoryHeader = "";
    if (submenu.classList.contains("level-2")) {
      var pageLink = submenu.querySelector("a.page-link");
      categoryHeader = document.createElement("div");
      categoryHeader.classList.add("mm-link-category");
      if (pageLink) {
        var categoryPageLink = document.createElement("a");
        categoryPageLink.href = pageLink.href;
        categoryPageLink.text = pageLink.text;
        categoryPageLink.classList.add("direct-link");
        categoryHeader.classList.add("direct-link-item");
        categoryHeader.appendChild(categoryPageLink);
      }
      if (!pageLink) categoryHeader.innerHTML = submenu.getAttribute("data-label");
    }
    var links = submenu.querySelectorAll(".subcategory.row a");
    var linkList = createGridLinksContainer(links);
    if (categoryHeader) linksContainer.appendChild(categoryHeader);
    linksContainer.appendChild(linkList);
  });
}
function createGridLinksContainer(links) {
  var linkList = document.createElement("ul");
  linkList.classList.add("mm-category-links");
  links.forEach(function (link) {
    var newLink = document.createElement("a");
    newLink.href = link.href;
    newLink.text = general_utils.decodeHTMLEntities(link.querySelector("span:first-of-type").innerHTML);
    var listItem = document.createElement("li");
    listItem.appendChild(newLink);
    linkList.appendChild(listItem);
  });
  return linkList;
}
function setupFeaturedLinksContainer(firstLevel, linksContainer) {
  var featuredLinks = firstLevel.querySelectorAll(".mm-grid-featured a");
  if (featuredLinks.length) {
    var featuredLinksHeader = document.createElement("div");
    var featuredLinksList = document.createElement("ul");
    featuredLinksHeader.classList.add("mm-link-category", "mm-mobile-featured-container");
    featuredLinksHeader.innerHTML = "Featured";
    featuredLinksList.classList.add("mm-featured-links");
    var uniqueLinks = general_utils.removeDupsInAssociativeArrayByKey(featuredLinks, "href");
    general_utils.sortArrayAlphabeticalByKey(uniqueLinks);
    uniqueLinks.forEach(function (featuredLink) {
      featuredLink = featuredLink.cloneNode(true);
      var newLink = document.createElement("li");
      newLink.appendChild(featuredLink);
      featuredLinksList.appendChild(newLink);
    });
    if (featuredLinksList) {
      linksContainer.appendChild(featuredLinksHeader);
      linksContainer.appendChild(featuredLinksList);
    }
  }
}
function setupLandingPageLink(firstLevel, linksContainer) {
  var landingPageLink = firstLevel.querySelector(".mm-landing-page-banner-link") ? firstLevel.querySelector(".mm-landing-page-banner-link").cloneNode(true) : "";
  if (landingPageLink) linksContainer.appendChild(landingPageLink);
}
function setupLandingPageLinkNoSubmenu(firstLevel, categoryName) {
  var mobileCategoryElement = document.querySelector(".mm-links-container #mm-mobile-menu-".concat(general_utils.webFriendlyName(categoryName)));
  var pageLinkContainer = document.createElement("div");
  var pageLink = document.createElement("a");
  pageLinkContainer.classList.add("mm-landing-page-link");
  pageLink.text = "View ".concat(categoryName, " Page");
  pageLink.href = firstLevel.querySelector("a").getAttribute("href");
  pageLink.classList.add("btn", "tertiary");

  //add link to container
  pageLinkContainer.appendChild(pageLink);
  if (mobileCategoryElement) mobileCategoryElement.parentNode.insertBefore(pageLinkContainer, mobileCategoryElement.nextSibling);
}

},{"../../../_utils/general_utils":15}],9:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backToTopShowHide = backToTopShowHide;
exports.processMobileSections = processMobileSections;
exports.showBackToTop = showBackToTop;
exports.toggleMobileMegaMenu = toggleMobileMegaMenu;
var general_utils = _interopRequireWildcard(require("../../../_utils/general_utils"));
var mm_mobile_helpers = _interopRequireWildcard(require("./farmers_mm_mobile_helpers"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function processMobileSections() {
  window.addEventListener("DOMContentLoaded", function () {
    var firstLevelMenus = document.querySelectorAll(".tbm-item.level-1");
    var linksContainer = document.querySelector(".mm-links-container");
    firstLevelMenus.forEach(function (firstLevel) {
      var categoryName = firstLevel.querySelector(".tbm-link-container a").firstChild.nodeValue.trim();
      if (categoryName.toLowerCase() === "home") return;
      mm_mobile_helpers.setupFirstLevelTab(firstLevel, categoryName, linksContainer);
      var sideMenu = firstLevel.querySelectorAll(".tbm-item.level-2");
      var submenus = sideMenu.length ? sideMenu : firstLevel.querySelectorAll(".mm-card-grid .subcategory.row");

      // setup mobile link depending on what type of section it is (categories vs. none)
      if (submenus.length) {
        mm_mobile_helpers.setupMobileGridLinks(firstLevel, submenus, linksContainer);
        mm_mobile_helpers.setupFeaturedLinksContainer(firstLevel, linksContainer);
        mm_mobile_helpers.setupLandingPageLink(firstLevel, linksContainer);
      }
      if (!submenus.length) mm_mobile_helpers.setupLandingPageLinkNoSubmenu(firstLevel, categoryName);
    });
  });
}
function backToTopShowHide() {
  window.addEventListener("load", function () {
    var backToTop = document.querySelector(".back-to-top.mm-back-to-top");
    var navContainer = document.querySelector("#mm-mobile .nav-container");
    if (navContainer) {
      navContainer.addEventListener("scroll", function (element) {
        var position = document.querySelector("#mm-mobile .mm-links-container .mm-mobile-nav-category").getBoundingClientRect().y;
        var closeButtonHeight = document.querySelector(".mm-mobile-menu-close").getBoundingClientRect().height;
        var calcluatedPosition = position - closeButtonHeight;
        if (calcluatedPosition <= 0) showBackToTop(true);
        if (calcluatedPosition > 0) showBackToTop(false);
      });
    }
  });
}
function showBackToTop(show) {
  var backToTop = document.querySelector(".back-to-top.mm-back-to-top");
  var visibilityStyle = show ? "visible" : "hidden";
  backToTop.style.visibility = visibilityStyle;
}
function toggleMobileMegaMenu(action) {
  var openClass = "animation-slide-in";
  var closeClass = "animation-slide-out";
  if (action === "open") {
    document.querySelector(".nav-container").classList.remove(closeClass);
    document.querySelector(".nav-container").classList.add(openClass);
  }
  if (action === "close") {
    document.querySelector(".nav-container").classList.remove(openClass);
    document.querySelector(".nav-container").classList.add(closeClass);
    document.querySelector(".back-to-top.mm-back-to-top").style.visibility = "hidden";
  }
}

},{"../../../_utils/general_utils":15,"./farmers_mm_mobile_helpers":8}],10:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeAllMenus = closeAllMenus;
exports.closeOnOutsideClick = closeOnOutsideClick;
exports.disableLinkContainerEvents = disableLinkContainerEvents;
exports.menuClickEvents = menuClickEvents;
exports.processSubmenuBanner = processSubmenuBanner;
exports.scrollEvents = scrollEvents;
exports.setFirstSideMenuLinkAsActive = setFirstSideMenuLinkAsActive;
exports.setPanelMinHeight = setPanelMinHeight;
exports.setupNavLinks = setupNavLinks;
exports.setupSecondLevelLinks = setupSecondLevelLinks;
exports.toggleContentOverlay = toggleContentOverlay;
var mm_accessibility = _interopRequireWildcard(require("./accessibility/farmers_mm_accessibility"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function closeOnOutsideClick() {
  document.addEventListener("click", function (event) {
    var isClickInside = document.querySelector(".tbm").contains(event.target) ? true : false;
    if (!isClickInside) {
      closeAllMenus();
      toggleContentOverlay(false);
      // mm_accessibility.ariaCheck();
    }
  });
}
function menuClickEvents() {
  var levelOneLinksDropdowns = document.querySelectorAll(".tbm-item.level-1.tbm-item--has-dropdown");
  levelOneLinksDropdowns.forEach(function (section) {
    var link = section.querySelector("a");
    if (!!link) {
      section.querySelector("a").addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var sideMenuFirstLink = section.querySelector(".tbm-item.level-2.tbm-item--has-flyout");
        var button = section.querySelector("button");
        if (!!button) button.click();
        setFirstSideMenuLinkAsActive(link, sideMenuFirstLink);
      });

      // button
      section.querySelector("button").addEventListener("click", function (event) {
        var toggleVar = section.classList.contains("open") ? false : true;
        var sideMenuFirstLink = section.querySelector(".tbm-item.level-2.tbm-item--has-flyout");
        setFirstSideMenuLinkAsActive(link, sideMenuFirstLink);
        toggleContentOverlay(toggleVar);
      });
    }
  });
}
function disableLinkContainerEvents() {
  // IMPORTANT:  Overides Drupal 10 TB Megamenu module
  // disable clicks in container links.
  var containers = document.querySelectorAll(".tbm-item.level-2.tbm-item--has-flyout .mega-dropdown-inner");
  containers.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  });
  var containerLinks = document.querySelectorAll(".tbm-item.level-2.tbm-item--has-flyout .mega-dropdown-inner a");
  containerLinks.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = event.currentTarget.href;
    });
  });
}
function setFirstSideMenuLinkAsActive(link, sideMenuFirstLink) {
  if (!!sideMenuFirstLink) {
    sideMenuFirstLink.classList.remove("open");
    if (link.getAttribute("aria-expanded") === "false") sideMenuFirstLink.classList.add("open");
  }
}
function scrollEvents() {
  document.addEventListener("scroll", function (event) {
    var openMenu = document.querySelector(".level-1.open");
    if (openMenu) {
      var openSubMenu = openMenu.querySelector(".mm-card-grid");
      var openMenuCoords = openSubMenu ? openSubMenu.getBoundingClientRect() : null;
      if (!!openMenuCoords && openMenuCoords.y * -1 - openMenuCoords.height >= 300) {
        toggleContentOverlay();
        openMenu.classList.remove("open");
        // mm_accessibility.ariaCheck();
      }
    }
  });
}
function toggleContentOverlay(force_block) {
  var overlay = document.querySelector(".usa-overlay");
  var display = "none";
  var docHeight = document.querySelector("html").getBoundingClientRect().height - document.querySelector("header").getBoundingClientRect().height;
  document.querySelector(".usa-overlay").style.height = "".concat(docHeight, "px");
  if (overlay.style.display === "none") display = "block";
  if (force_block === false || overlay.style.display === "block") display = "none";
  if (!!force_block && force_block !== false) display = "block";
  overlay.style.display = display;

  // mm_accessibility.ariaCheck();
  // blurNonOpenFirstLevelLink();
}
function setupNavLinks() {
  var firstLevelSelector = ".tbm-item.level-1";
  var firstLevelOpenSelector = "".concat(firstLevelSelector, ".open");
  var firstLevel = document.querySelectorAll(firstLevelSelector);
  var languages = require("../../../constants").languages;
  var langHomePages = languages.map(function (row) {
    return row.lang === "en" ? "/" : "/".concat(row.lang);
  });
  firstLevel.forEach(function (item) {
    processSubmenuBanner(item);
    setPanelMinHeight(item);
  });
  var submenus = document.querySelectorAll(".level-1 > div.tbm-submenu.tbm-item-child.nav-submenu");
  submenus.forEach(function (submenu) {
    var sidemenuLinks = submenu.querySelectorAll(".tbm .sidemenu .tbm-item.level-2.tbm-item--has-flyout");
    if (sidemenuLinks) {
      sidemenuLinks.forEach(function (link) {
        var linkSubMenu = link.querySelector(".tbm-submenu.tbm-item-child.nav-submenu");
        var cardGridHeight = linkSubMenu.getBoundingClientRect().height;
        if (cardGridHeight) link.querySelector(".tbm-toggle").setAttribute("data-grid-card-height", cardGridHeight);

        // click events
        link.addEventListener("click", function (event) {
          if (!!link.classList.contains("open")) {
            event.preventDefault();
            return;
          }
          var childSubMenus = document.querySelectorAll(".level-2 .tbm-submenu.tbm-item-child.nav-submenu");
          if (!!childSubMenus) childSubMenus.forEach(function (menu) {
            menu.style.left = "-999999999px";
          });
          var cardHeight = link.querySelector(".tbm-toggle").getAttribute("data-grid-card-height");
          submenu.style.minHeight = "".concat(Number(cardHeight) + 70, "px");
          setTimeout(function () {
            childSubMenus.forEach(function (menu) {
              menu.style.left = null;
            });
          }, 100);
        });
      });
    }
    // const link = item.querySelector("a");
    // const activeLinkClass = "mm-active";

    // if (
    //   langHomePages.includes(link.getAttribute("data-label")) &&
    //   langHomePages.includes(window.location.pathname)
    // )
    //   link.classList.add(activeLinkClass);

    // if (!langHomePages.includes(link.getAttribute("data-label"))) {
    //   const dataLabelLength = link.getAttribute("data-label").length;
    //   const anchorLink = window.location.pathname.substring(0, dataLabelLength);

    //   if (anchorLink === link.getAttribute("data-label"))
    //     link.classList.add(activeLinkClass);

    //   if (!link.classList.contains("page-link")) {
    //     if (!item.querySelector(".sidemenu")) item.classList.add("no-sidemenu");

    //     link.addEventListener("click", (event) => {
    //       if (item.classList.contains("open")) {
    //         item.classList.remove("open");
    //         mm_accessibility.ariaCheck();
    //       } else if (!item.classList.contains("open")) {
    //         processLinkStyles(item, firstLevelOpenSelector);
    //         processLinkStyles(item, `${firstLevelOpenSelector} .level-2`);

    //         const firstSidemenuLink = item.querySelector(
    //           ".sidemenu li:first-child",
    //         );
    //         if (item.classList.contains("open") && firstSidemenuLink) {
    //           firstSidemenuLink.classList.add("open");
    //           firstSidemenuLink
    //             .querySelector("a")
    //             .classList.add("sidemenu-hover");
    //           setSubMenuDimensions();
    //         }
    //         if (item.classList.contains("no-sidemenu")) setSubMenuDimensions();
    //         mm_accessibility.ariaCheck();
    //         item.querySelector("a").focus();
    //       }
    //       toggleContentOverlay(item);
    //     });
    //   }
    // }
  });
}
function setupSecondLevelLinks() {
  var sidemenus = document.querySelectorAll(".tbm-subnav.level-1.sidemenu");
  var top = document.querySelector(".tbm-submenu.tbm-item-child.nav-submenu").getBoundingClientRect().top;
  sidemenus.forEach(function (sidmenu) {
    sidmenu.querySelectorAll("li.tbm-item.level-2").forEach(function (item, idx) {
      var submenu = item.querySelector(".tbm-submenu.tbm-item-child.nav-submenu");
      if (!!submenu) {
        var topDifference = top - submenu.getBoundingClientRect().top + 70;
        submenu.style.top = "".concat(topDifference, "px");
      }
    });
  });
}
function processSubmenuBanner(item) {
  var linkText = item.querySelector("a").text.trim();
  var originalBanner = document.querySelector(".mm-landing-page-banner[data-label='".concat(linkText, "']"));
  var landingPageBanner = originalBanner ? originalBanner.cloneNode(true) : "";
  if (landingPageBanner) {
    // const submenuLevel1 = item.querySelector(
    //   ".tbm-submenu.tbm-item-child.nav-submenu",
    // );
    var submenuLevel1 = item.querySelector(".mega-dropdown-inner");
    if (submenuLevel1) {
      submenuLevel1.prepend(landingPageBanner);
      landingPageBanner.classList.add("show-mm-landing-page-banner");
    }
  }
}
function setPanelMinHeight(item) {
  var targetNode = item;
  var config = {
    attributes: true,
    childList: true
  };
  var callback = function callback(mutationsList, observer) {
    if (item.classList.contains("open")) {
      var sideMenu = item.querySelector(".tbm-submenu.tbm-item-child.nav-submenu");
      if (!!sideMenu) {
        var submenu = item.querySelector("li.tbm-item.level-2.tbm-item--has-flyout.open > div.tbm-submenu.tbm-item-child.nav-submenu");
        var height = !!submenu ? submenu.getBoundingClientRect().height : 200;
        // add height of section banner
        sideMenu.style.minHeight = "".concat(height + 70, "px");
      }
    }
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// export function isSafari() {
//   let safari = false;
//   if (
//     navigator.userAgent.indexOf("Safari") != -1 &&
//     navigator.userAgent.indexOf("Chrome") == -1
//   ) {
//     safari = true;
//   }
//   return safari;
// }

function closeAllMenus(event) {
  var overlay = document.querySelector(".usa-overlay");
  var openLinks = document.querySelectorAll(".tbm-item.level-1.open");
  openLinks.forEach(function (link) {
    link.querySelector("a").click();
  });
  if (event && overlay.style.display !== "none") toggleContentOverlay();
}

},{"../../../constants":16,"./accessibility/farmers_mm_accessibility":6}],11:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.megamenu_mobile = void 0;
var mm_mobile_utils = _interopRequireWildcard(require("./_utils/farmers_mm_mobile_utils"));
var general_utils = _interopRequireWildcard(require("../../_utils/general_utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var megamenu_mobile = exports.megamenu_mobile = function megamenu_mobile() {
  mm_mobile_utils.processMobileSections();
  mm_mobile_utils.backToTopShowHide();
  if (document.querySelector(".tbm")) {
    var megaMenuMobile = document.querySelector(".mm-mobile-primary-nav.megamenu");
    var signUpElement = !!document.querySelector(".header-button") ? document.querySelector(".header-button") : "";
    var signUpButtonsElement = !!document.querySelector(".utility-nav-buttons") ? document.querySelector(".utility-nav-buttons") : "";
    var searchElement = document.getElementById("search-field");
    var signupNode = signUpElement ? signUpElement.cloneNode(true) : null;
    var searchNode = searchElement ? searchElement.cloneNode(true) : null;
    if (!signupNode && !!signUpButtonsElement) signupNode = signUpButtonsElement.cloneNode(true);
    setUpUtilityNav(megaMenuMobile);
    var headerSearchId = "header-search-mobile";

    // start 508 fixes
    searchNode.id = "search-field-mobile";
    searchNode.querySelector("#affiliatename").id = "affiliatename-mobile";
    searchNode.querySelector("label").setAttribute("for", headerSearchId);
    searchNode.querySelector("#header-search").id = headerSearchId;
    searchNode.querySelector("div[aria-label='Site Search']").ariaLabel = "Mobile Site Search";
    // end 508 fixes
    // copy nodes to menu
    if (signupNode) {
      var signupNodeLinks = signupNode.querySelectorAll("a");
      signupNodeLinks.forEach(function (link) {
        general_utils.removeClassIfExists(link, "tertiary");
        general_utils.addClassIfDoesntExist(link, "sm-btn");
        general_utils.addClassIfDoesntExist(link, "outline");
      });
      megaMenuMobile.querySelector(".mm-signup").innerHTML = signupNode.outerHTML;
    }
    if (searchNode) megaMenuMobile.querySelector(".mm-search").innerHTML = searchNode.outerHTML;
    var topNav = document.querySelector(".mm-top-nav");
    var linksContainer = megaMenuMobile.querySelector(".mm-links-container");
    document.getElementById("mm-mobile").addEventListener("click", function (event) {
      if (event.target.classList.contains("mm-mobile-primary-nav")) {
        document.body.classList.toggle("mobile-menu-active");
        document.querySelector(".mm-mobile-primary-nav").style.display = "none";
      }
    });
    document.querySelector(".mobile-megamenu-button").addEventListener("click", function (element) {
      document.body.classList.add("mobile-menu-active");
      mm_mobile_utils.toggleMobileMegaMenu("open");
      var megaMenuMobileDisplay = window.getComputedStyle(megaMenuMobile).getPropertyValue("display");
      if (megaMenuMobileDisplay === "none") {
        megaMenuMobile.style.display = "flex";
      } else {
        megaMenuMobile.style.display = "none";
      }
    });
    document.querySelector(".mm-mobile-menu-close").addEventListener("click", function (element) {
      mm_mobile_utils.toggleMobileMegaMenu("close");
      document.body.classList.remove("mobile-menu-active");
    });
    megaMenuMobile.addEventListener("animationend", function () {
      if (document.querySelector(".nav-container").classList.contains("animation-slide-out")) megaMenuMobile.style.display = "none";
    });
    var firstLevelMenus = document.querySelectorAll(".tbm-item.level-1");
    firstLevelMenus.forEach(function (element) {
      var decodeHTML = function decodeHTML(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      };
      var linkText = element.querySelector(".tbm-link-container a").innerHTML.trim();
      if (linkText.toLowerCase() === "home") return;
      var listItem = document.createElement("li");
      var link = document.createElement("a");
      var subMenu = element.querySelector(".tbm-item.level-2") ? element.querySelector(".tbm-item.level-2").cloneNode(true) : "";
      link.text = general_utils.decodeHTMLEntities(linkText);
      link.href = "#mm-mobile-menu-".concat(general_utils.webFriendlyName(linkText));
      link.classList.add("mm-mobile-top-nav");
      link.setAttribute("aria-label", "Jump to " + linkText);
      if (topNav) {
        listItem.appendChild(link);
        topNav.appendChild(listItem);
      }
    });
    var navJumpLinks = document.querySelectorAll(".mm-mobile-top-nav:not(.home)");
    navJumpLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var navContainer = document.querySelector("#mm-mobile .nav-container");
        var closeButtonHeight = document.querySelector(".mm-mobile-menu-close").getBoundingClientRect().height;
        var position = document.querySelector(event.target.hash).getBoundingClientRect().y;
        var calcluatedPosition = position - closeButtonHeight;
        navContainer.scrollTop = calcluatedPosition;
      });
    });
    document.querySelector(".back-to-top.mm-back-to-top").addEventListener("click", function (event) {
      event.stopPropagation();
      document.getElementById("mm-mobile-header").scrollIntoView();
    });
    document.addEventListener("click", function (event) {
      var clickedInside = document.querySelector("#mm-mobile .nav-container").contains(event.target) ? true : false;
      if (!clickedInside && !event.target.classList.contains("mobile-megamenu-button") && !event.target.classList.contains("mm-back-to-top")) {
        mm_mobile_utils.showBackToTop(false);
        megaMenuMobile.addEventListener("animationend", function () {
          if (document.querySelector(".nav-container").classList.contains("animation-slide-out")) megaMenuMobile.style.display = "none";
        });
      }
    });
    window.addEventListener("popstate", mm_mobile_utils.backToTopShowHide());
  }
};
function setUpUtilityNav(megaMenuMobile) {
  var utilityNavElement = document.querySelector(".utility-nav");
  var utilityNav = utilityNavElement ? utilityNavElement.cloneNode(true) : null;
  var brandingBarMenu = document.getElementById("nav-branding-bar");
  if (!!brandingBarMenu) brandingBarMenu.querySelector("ul").classList.add("mm-branding-bar-menu");
  if (utilityNav) {
    var utilNavMarkup = !!brandingBarMenu ? "".concat(brandingBarMenu.innerHTML, " ").concat(utilityNav.innerHTML) : utilityNav.innerHTML;
    megaMenuMobile.querySelector(".mm-utility-nav").innerHTML = utilNavMarkup;
  }
  utilityNav.querySelector("ul").className = "";
}

},{"../../_utils/general_utils":15,"./_utils/farmers_mm_mobile_utils":9}],12:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.megamenu = void 0;
var mm_utils = _interopRequireWildcard(require("./_utils/farmers_mm_utils"));
var mm_accessibility = _interopRequireWildcard(require("./_utils/accessibility/farmers_mm_accessibility"));
var mm_mobile = _interopRequireWildcard(require("./farmers_mm_mobile.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Compatible with Drupal TB Mega Menu Versions:
// 3.0.0-alpha2

var megamenu = exports.megamenu = function megamenu() {
  if (document.querySelector(".tbm")) {
    console.log("loading megamenu...");
    mm_utils.setupNavLinks();
    mm_utils.setupSecondLevelLinks();
    mm_utils.menuClickEvents();
    mm_utils.scrollEvents();
    mm_utils.disableLinkContainerEvents();
    // mm_utils.setupSideMenuLinks();
    mm_utils.closeOnOutsideClick();
    // mm_accessibility.keyboardEventListeners();
    // mm_accessibility.ariaCheck();

    document.addEventListener("keydown", function (event) {
      mm_accessibility.handleKeyboard(event);
    });
  }
};

// initiate megamenus
megamenu();
mm_mobile.megamenu_mobile();

},{"./_utils/accessibility/farmers_mm_accessibility":6,"./_utils/farmers_mm_utils":10,"./farmers_mm_mobile.js":11}],13:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
window.addEventListener('load', function () {
  var helper = function helper(element, className) {
    if (!!element) {
      if (element.classList.contains(className)) {
        return element;
      } else {
        return helper(element.parentElement, className);
      }
    }
  };
  var megamenuButtons = document.querySelectorAll('.accordion-button.nav-link');
  if (megamenuButtons) {
    _toConsumableArray(megamenuButtons).map(function (elm) {
      var submenu = elm.nextElementSibling;
      elm.addEventListener('click', function (evt) {
        evt.preventDefault();
        var elmExpanded = elm.getAttribute('aria-expanded');
        var submenuHidden = submenu.getAttribute('aria-hidden');

        //remove existing submenus
        var openSubmenus = document.querySelectorAll('.submenu-item-active');
        _toConsumableArray(openSubmenus).map(function (el) {
          el.classList.remove('submenu-item-active');
        });

        // reveal appropriate submenu
        if (elmExpanded == 'false') {
          elm.classList.add('submenu-item-active');
          elm.setAttribute('aria-expanded', 'true');
          submenu.setAttribute('aria-hidden', 'false');
        } else {
          elm.classList.remove('submenu-item-active');
          elm.setAttribute('aria-expanded', 'false');
          submenu.setAttribute('aria-hidden', 'true');
        }
      });
      elm.addEventListener('keyup', function (event) {
        if (event.key == " " || event.key == "Enter") {
          event.preventDefault();
          elm.click();
        }
      });
    });
  }
  var submenuItems = document.querySelectorAll('.nav-submenu > .has-submenu');
  if (submenuItems) {
    _toConsumableArray(submenuItems).map(function (elm) {
      elm.addEventListener('click', function (evt) {
        evt.preventDefault();
        _toConsumableArray(submenuItems).map(function (elm2) {
          elm2.classList.remove('submenu-item-active');
        });
        elm.classList.toggle('submenu-item-active');
      });
    });
  }
  var govBannerButtons = document.querySelectorAll('button.usa-accordion-button.usa-banner-button');
  if (govBannerButtons) {
    _toConsumableArray(govBannerButtons).map(function (item) {
      item.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var ariaVal = item.getAttribute('aria-expanded');
        var banner = helper(item.parentElement, 'usa-accordion').querySelector('div[id^="gov-banner"]');
        var newVal = ariaVal == 'true' ? 'false' : 'true';
        var hideContainer = newVal == 'false' ? 'true' : 'false';
        helper(item.parentElement, 'usa-accordion').querySelector('.usa-banner-header').classList.toggle('usa-banner-header-expanded');
        item.setAttribute('aria-expanded', newVal);
        banner.setAttribute('aria-hidden', hideContainer);
      });
    });
  }
});

},{}],14:[function(require,module,exports){
"use strict";

window.addEventListener("load", function () {
  setTimeout(function () {
    var tables = document.querySelectorAll("table");
    if (!!tables.length) startDocWatcher();
    saveTableWidths();
    processMobileTables();
  }, "750");
});
window.addEventListener("resize", function () {
  processMobileTables();
});
function startDocWatcher() {
  // watch for changes in the document to re-process mobile
  // tables when there is dynamic content (like in tools)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      setTimeout(function () {
        processMobileTables();
      }, "750");
    });
  });
  observer.observe(document.body, {
    characterDataOldValue: true,
    subtree: true,
    childList: true,
    characterData: true
  });
}
function saveTableWidths() {
  var key = "ds_table_widths";
  sessionStorage.removeItem(key);
  var tables = document.querySelectorAll("table");
  var widths = [];
  if (!!tables.length) {
    tables.forEach(function (table, idx) {
      widths.push({
        index: idx,
        tableWidth: table.getBoundingClientRect().width
      });
    });
  }
  sessionStorage.setItem(key, JSON.stringify(widths));
}
function processMobileTables() {
  var tables = document.querySelectorAll("table");
  if (!!tables.length) {
    tables.forEach(function (table, idx) {
      if (!!table.classList && table.classList.contains("mobile-static-column") && !table.classList.contains("show-mobile-static-column")) {
        processStaticColTable(table, idx);
        setupStaticColContainer(table);
      }
      var headers = table.querySelectorAll("thead th");
      var dataRows = table.querySelectorAll("tr");
      var headersInData = table.querySelectorAll("tbody th");
      var simpleTable = checkIfSimpleTable(table, headers, dataRows, headersInData);
      if (!simpleTable) {
        if (table.classList.contains("mobile-static-column")) return;
        table.classList.add("show-on-mobile");
        table.classList.add("complex-table");
      }
      if (!!simpleTable) setupTableForMobile(table);
      setTimeout(function () {
        if (!table.classList.contains("show-on-mobile")) table.classList.add("show-on-mobile");
      }, 2000);
    });
  }
}
function processStaticColTable(table, idx) {
  var staticColClass = "show-mobile-static-column";
  var widths = JSON.parse(sessionStorage.getItem("ds_table_widths"));
  var bodyWidth = document.body.getBoundingClientRect().width;
  table.classList.add("full-width");

  // if the table goes outside of the body container, add class
  // to activate static column
  if (!!widths[idx] && widths[idx].tableWidth > bodyWidth && table.getBoundingClientRect().width > bodyWidth) table.classList.add(staticColClass);

  // if the table is inside of the body container, remove class
  // for static column
  if (!!widths[idx] && widths[idx].tableWidth < bodyWidth && table.getBoundingClientRect().width < bodyWidth) table.classList.remove(staticColClass);

  // if there's a large margin between the table and right
  // margin of the body, remove the static column class
  if (bodyWidth - table.getBoundingClientRect().width > 50 && !!table.classList.contains("show-mobile-static-column")) table.classList.remove(staticColClass);
}
function setupStaticColContainer(table) {
  if (table.classList.contains("mobile-static-column") && !table.closest(".mobile-static-column-container")) {
    var tableStaticCol = table.cloneNode(true);
    var newDiv = document.createElement("div");
    tableStaticCol.classList.add("show-on-mobile");
    newDiv.classList.add("mobile-static-column-container");
    newDiv.appendChild(tableStaticCol);
    table.after(newDiv);
    table.remove();
  }
}
function setupTableForMobile(table) {
  if (table.classList.contains("mobile-static-column")) return;
  table.classList.add("simple-table");
  var rows = table.querySelectorAll("tr");
  var headerData = [];
  if (!!rows) {
    rows.forEach(function (row) {
      var headerCells = row.querySelectorAll("th");
      var tableCells = row.querySelectorAll("td");

      // if (tableCells.length <= 2) table.classList.remove("simple-table");

      if (!!headerCells.length) {
        headerData = [];
        headerCells.forEach(function (th) {
          headerData.push(th.textContent.trim());
        });
      }
      if (!!tableCells) {
        tableCells.forEach(function (td, idx) {
          td.setAttribute("data-th", headerData[idx]);
        });
      }
    });
  }
}
function checkIfSimpleTable(table, headers, dataRows, headersInData) {
  var integer = 0;
  if (!!table.classList && table.classList.contains("ui-datepicker-calendar")) integer++;
  headers.forEach(function (header) {
    if (header.hasAttribute("colspan") || header.hasAttribute("rowspan")) integer++;
  });
  dataRows.forEach(function (row) {
    var dataHeaders = row.querySelectorAll("th");
    var dataCells = row.querySelectorAll("td");
    if (checkForColAndRowSpan(dataHeaders)) integer++;
    if (checkForColAndRowSpan(dataCells)) integer++;
  });
  return integer === 0 ? true : false;
}
function checkForColAndRowSpan(elements) {
  var integer = 0;
  elements.forEach(function (element) {
    if (element.hasAttribute("colspan") || element.hasAttribute("rowspan")) integer++;
  });
  return !!integer ? true : false;
}

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClassIfDoesntExist = addClassIfDoesntExist;
exports.convertNodeListToArray = convertNodeListToArray;
exports.decodeHTMLEntities = decodeHTMLEntities;
exports.detectDeviceType = detectDeviceType;
exports.formatYouTubeUrl = formatYouTubeUrl;
exports.removeClassIfExists = removeClassIfExists;
exports.removeDupsInAssociativeArrayByKey = removeDupsInAssociativeArrayByKey;
exports.removeHtmlComments = removeHtmlComments;
exports.removeUrlParams = removeUrlParams;
exports.sortArrayAlphabeticalByKey = sortArrayAlphabeticalByKey;
exports.webFriendlyName = webFriendlyName;
function removeUrlParams() {
  var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname);
  window.history.replaceState({}, document.title, newurl);
}
function removeHtmlComments(html) {
  return html.replace(/<!--[\s\S]*?-->/g, "").trim();
}
function convertNodeListToArray(nodeList) {
  return Array.from(nodeList);
}
function webFriendlyName(text) {
  text = text.replace(/\s+/g, "-").toLowerCase();
  text = text.replace(/[^a-z0-9\-]+/gi, "");
  return text;
}
function removeDupsInAssociativeArrayByKey(array, key) {
  var newArray = [];
  var uniqueObject = {};
  var i = 0;
  for (var _i in array) {
    var obj = array[_i][key];
    uniqueObject[obj] = array[_i];
    _i++;
  }
  for (i in uniqueObject) if (i !== "undefined") newArray.push(uniqueObject[i]);
  return newArray;
}
function sortArrayAlphabeticalByKey(array, key) {
  if (!key) key = "text";
  array.sort(function (a, b) {
    if (a[key] > b[key]) return 1;
    if (a[key] < b[key]) return -1;
    return 0;
  });
}
function decodeHTMLEntities(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
function addClassIfDoesntExist(element, className) {
  if (!!element && !element.classList.contains(className)) element.classList.add(className);
}
function removeClassIfExists(element, className) {
  if (!!element && element.classList.contains(className)) element.classList.remove(className);
}
function formatYouTubeUrl(url) {
  var videoCode;
  var youTubeUrl = "https://www.youtube.com/watch?v=";
  if (url.indexOf("embed") !== -1) {
    var array = url.split("embed/");
    var _videoCode = !!array[1] ? array[1].split("?")[0] : "";
    if (!!_videoCode) url = "".concat(youTubeUrl).concat(_videoCode);
  }
  return url;
}
function detectDeviceType() {
  // window variables are set when farmers.js is loaded
  var deviceType = "";
  if (window.is_mobile_device && !window.is_iPad) deviceType = "phone";
  if (window.is_iPad) deviceType = "ipad";
  if (!window.is_mobile_device && !window.is_iPad) deviceType = "desktop";
  return deviceType;
}

},{}],16:[function(require,module,exports){
"use strict";

exports.languages = [{
  lang: "en",
  en_text: "English",
  i18n_text: "English"
}, {
  lang: "es",
  en_text: "Spanish",
  i18n_text: "Español"
}];

},{}],17:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("./Components/accordion");
require("./Components/menu");
require("./Components/mobile_tables");
require("./Components/megamenu/tb-mega-menu-custom.2.0.0");
require("./Components/forms/_forms");
var back_to_top = _interopRequireWildcard(require("./Components/back_to_top"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
window.is_iPad = navigator.userAgent.match(/iPad/i) != null;
window.is_mobile_device = false; //initialize as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  window.is_mobile_device = true;
}
back_to_top.setup();

},{"./Components/accordion":1,"./Components/back_to_top":2,"./Components/forms/_forms":4,"./Components/megamenu/tb-mega-menu-custom.2.0.0":12,"./Components/menu":13,"./Components/mobile_tables":14}]},{},[17]);
